import React from "react";
import styled from "styled-components";
import PretendardText from "../atoms/text/pretendardText";

function TableCount2(props) {
  return (
    <>
      <TableCountWrapper>
        <PretendardText
          style={{
            fontSize: "14px",
            fontWeight: "600",
            lineHeight: "22.75px",
            color: "#ADB4BA",
          }}
        >
          {props.text ? props.text : `전체 ${props.text} 수`}
        </PretendardText>
        <PretendardText
          style={{
            fontSize: "14px",
            fontWeight: "600",
            lineHeight: "22.75px",
            color: "#262C31",
          }}
        >
          {props.count || "000"}
        </PretendardText>
      </TableCountWrapper>
    </>
  );
}

export default TableCount2;

const TableCountWrapper = styled.div.attrs((props) => {})`
  display: flex;
  align-items: center;
  gap: 7px;
`;
